export interface INav {
  navname: string;
  navClassName: string;
  iconSrc: string;
  path: string;
}

export const navList: INav[] = [
  {
    navname: 'Revenue',
    navClassName: 'wizard-box wizard-bg-gray',
    iconSrc: './assets/images/Revenue.svg',
    path: '/revenue-landing',
  },
  {
    navname: 'Scheme',
    navClassName: 'wizard-box wizard-bg-light-blue',
    iconSrc: './assets/images/Schemes.svg',
    path: '/CMA/cmadashboard/0',
  },
  {
    navname: 'Citizen Service',
    navClassName: 'wizard-box bg-white',
    iconSrc: './assets/images/Citizen Services.svg',
    path: '',
  },
  {
    navname: 'Building Plan',
    navClassName: 'wizard-box wizard-bg-gray',
    iconSrc: './assets/images/Building Plan.svg',
    path: '',
  },
  {
    navname: 'Trade License',
    navClassName: 'wizard-box bg-dark-blue',
    iconSrc: './assets/images/Trade License.svg',
    path: '',
  },
  {
    navname: 'Birth and Death',
    navClassName: 'wizard-box wizard-bg-light-blue',
    iconSrc: './assets/images/Birth and Death.svg',
    path: '',
  },
  {
    navname: 'Accounts',
    navClassName: 'wizard-box wizard-white',
    iconSrc: './assets/images/Accounts.svg',
    path: '',
  },
  {
    navname: 'Engineering',
    navClassName: 'wizard-box wizard-bg-gray',
    iconSrc: './assets/images/Engineering.svg',
    path: '',
  },
  {
    navname: 'Court Case',
    navClassName: 'wizard-box bg-dark-blue',
    iconSrc: './assets/images/Court Cases.svg',
    path: '',
  },

  {
    navname: 'Assembly Question and Answer',
    navClassName: 'wizard-box wizard-bg-gray',
    iconSrc: './assets/images/Assemply Question-and Answers.svg',
    path: '',
  },
  {
    navname: 'Public Grievances',
    navClassName: 'wizard-box wizard-white',
    iconSrc: './assets/images/Public Grievances.svg',
    path: '',
  },
  {
    navname: 'Audit Paras',
    navClassName: 'wizard-box wizard-bg-gray',
    iconSrc: './assets/images/Audit Paras.svg',
    path: '',
  },
  {
    navname: 'User Details',
    navClassName: 'wizard-box bg-dark-blue',
    iconSrc: './assets/images/User Details.svg',
    path: '',
  },
  {
    navname: 'Recent Day Collection',
    navClassName: 'wizard-box wizard-bg-gray',
    iconSrc: './assets/images/Recent Days-Collection.svg',
    path: '',
  },
  {
    navname: 'Employee Performance',
    navClassName: 'wizard-box wizard-bg-light-blue',
    iconSrc: './assets/images/Employee-Performance.svg',
    path: '',
  },
];
